<template>
  <div>
    <Header :pageTitle="$route.params.title">
      <div slot="right" v-if="$route.params.canDownLoad" @click="toDownLoad">
        下载
      </div>
    </Header>
    <div id="reeading"></div>
  </div>
</template>

<script>
import Pdfh5 from "pdfh5";
import "pdfh5/css/pdfh5.css";
import { Dialog } from "vant";
import Header from "@/views/mobileView/components/header";
import { Toast } from "vant";
export default {
  components: {
    Header,
  },
  data() {
    return {
      pdfh5: null,
    };
  },
  mounted() {
    if (this.$route.params.url && this.$route.params.url !== "") {
      this.pdfh5 = new Pdfh5("#reeading", {
        pdfurl: this.$route.params.url,
      });
      this.pdfh5.on("complete", (status, msg, time) => {
        if (status == "error") {
          this.isError();
        }
      });
    } else {
      this.isError();
    }
  },
  methods: {
    isError() {
      Dialog({
        title: "错误",
        message: "文件打开失败,请尝试重新打开",
        theme: "round-button",
      }).then(() => {
        window.history.go(-1);
      });
    },
    toDownLoad() {
      Toast({
        message: "正在下载...",
        duration: 2500,
      });
      window.location.href = this.$route.params.url;
    },
  },
};
</script>

<style scoped lang="scss">
#reeading {
  padding-top: 56px;
  width: 100%;
  height: 100vh;
}

::v-deep .pdfjs {
  .pageNum {
    top: 90vh;
    // bottom: 20px;
  }
}
</style>